/**
 * SORRELLE · sitewide interactions (FAQ search, order tracking lookup, form status focus).
 * Loaded (deferred) by snippets/sorrelle-site-theme.liquid. Each block only runs when its markup is
 * on the page, and nothing here is needed to read or navigate the content.
 */
(function () {
  'use strict';

  if (window.__sorrelleSiteLoaded) return;
  window.__sorrelleSiteLoaded = true;

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  /* ---------- FAQ: filter questions as the customer types ---------- */

  function initFaq(root) {
    each((root || document).querySelectorAll('[data-sr-faq]'), function (faq) {
      if (faq.dataset.srBound) return;
      faq.dataset.srBound = 'true';

      var wrap = faq.querySelector('[data-sr-faq-search-wrap]');
      var input = faq.querySelector('[data-sr-faq-search]');
      var status = faq.querySelector('[data-sr-faq-status]');
      var nav = faq.querySelector('[data-sr-faq-nav]');
      var items = faq.querySelectorAll('[data-sr-faq-item]');
      var groups = faq.querySelectorAll('[data-sr-faq-group]');
      if (!wrap || !input) return;

      wrap.hidden = false;

      function filter() {
        var query = input.value.trim().toLowerCase();
        var shown = 0;
        each(items, function (item) {
          var match = !query || item.textContent.toLowerCase().indexOf(query) !== -1;
          item.hidden = !match;
          if (match) shown += 1;
        });
        each(groups, function (group) {
          group.hidden = !group.querySelector('[data-sr-faq-item]:not([hidden])');
        });
        if (nav) nav.hidden = !!query;
        if (status) {
          if (query && shown === 0) {
            status.textContent = status.dataset.empty || '';
            status.hidden = false;
          } else {
            status.textContent = '';
            status.hidden = true;
          }
        }
      }

      input.addEventListener('input', filter);
      input.addEventListener('search', filter);
    });
  }

  /* Open the question (or the first question of the group) named in the URL hash. */
  function openFromHash() {
    if (!window.location.hash || window.location.hash.length < 2) return;
    var target;
    try {
      target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    } catch (error) {
      return;
    }
    if (target && target.matches('details[data-sr-faq-item]')) target.open = true;
  }

  /* ---------- Order tracking: 17TRACK lookup, requested only on submit ---------- */

  var trackScript;

  function loadTracker() {
    if (window.YQV5) return Promise.resolve();
    if (trackScript) return trackScript;
    trackScript = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://www.17track.net/externalcall.js';
      script.async = true;
      script.onload = function () {
        if (window.YQV5) resolve();
        else reject(new Error('tracker unavailable'));
      };
      script.onerror = function () {
        trackScript = null;
        reject(new Error('tracker blocked'));
      };
      document.head.appendChild(script);
    });
    return trackScript;
  }

  function initTrack(root) {
    each((root || document).querySelectorAll('[data-sr-track]'), function (card) {
      if (card.dataset.srBound) return;
      card.dataset.srBound = 'true';

      var form = card.querySelector('[data-sr-track-form]');
      var input = card.querySelector('[data-sr-track-input]');
      var error = card.querySelector('[data-sr-track-error]');
      var result = card.querySelector('[data-sr-track-result]');
      var status = card.querySelector('[data-sr-track-status]');
      var widget = card.querySelector('[data-sr-track-widget]');
      var fallback = card.querySelector('[data-sr-track-fallback]');
      if (!form || !input || !result || !widget) return;

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var number = input.value.replace(/\s+/g, '').trim();

        if (!number) {
          if (error) error.hidden = false;
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        if (error) error.hidden = true;
        input.removeAttribute('aria-invalid');

        if (fallback) fallback.href = 'https://t.17track.net/en#nums=' + encodeURIComponent(number);
        result.hidden = false;
        widget.innerHTML = '';
        if (status) status.textContent = 'Looking up ' + number + '…';

        loadTracker()
          .then(function () {
            window.YQV5.trackSingle({
              YQ_ContainerId: widget.id,
              YQ_Height: 560,
              YQ_Fc: '0',
              YQ_Lang: 'en',
              YQ_Num: number,
            });
            if (status) status.textContent = 'Showing carrier tracking for ' + number + '.';
          })
          .catch(function () {
            if (status) {
              status.textContent =
                'We could not load tracking here. Use the link below to open your tracking in a new tab.';
            }
          });
      });

      input.addEventListener('input', function () {
        if (error && !error.hidden && input.value.trim()) {
          error.hidden = true;
          input.removeAttribute('aria-invalid');
        }
      });
    });
  }

  /* ---------- Forms: move focus to the confirmation or error summary after submitting ---------- */

  function focusFormStatus() {
    var status = document.querySelector('[data-sr-form-status]');
    if (!status) return;
    status.focus({ preventScroll: true });
    status.scrollIntoView({ block: 'center' });
  }

  function init(root) {
    initFaq(root);
    initTrack(root);
  }

  function ready() {
    init(document);
    openFromHash();
    focusFormStatus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
  window.addEventListener('hashchange', openFromHash);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
